import { z } from "zod";
export const FinanceTabSchema = z.enum(["pnl", "recognition", "trades", "positions", "stats", "statements", "margin", "delivery"]);
export const FinanceTabsSchema = z.array(FinanceTabSchema).max(8)
    .refine((tabs) => new Set(tabs).size === tabs.length, "Choose each tab only once");
export const DEFAULT_FINANCE_TABS = ["pnl", "recognition"];
export const FINANCE_TABS = [
    { id: "pnl", label: "P&L", path: "/eex/pnl" },
    { id: "recognition", label: "Recognition", path: "/eex/recognition-schedules" },
    { id: "trades", label: "Trades", path: "/eex/trades" },
    { id: "positions", label: "Positions", path: "/eex/positions-tree" },
    { id: "stats", label: "Stats", path: "/eex/stats" },
    { id: "statements", label: "Statements", path: "/eex/statements" },
    { id: "margin", label: "Margin", path: "/eex/margin" },
    { id: "delivery", label: "Delivery", path: "/eex/delivery" },
];
export const FinanceFunctionSchema = z.enum([
    "pnl.reports", "pnl.export_excel", "pnl.export_bonus", "pnl.export_gl",
    "recognition.compare", "trades.history", "trades.documents",
]);
export const FinanceFunctionsSchema = z.array(FinanceFunctionSchema).max(7)
    .refine((functions) => new Set(functions).size === functions.length, "Choose each function only once");
export const FINANCE_FUNCTIONS = [
    { id: "pnl.reports", tab: "pnl", label: "View finance reports, matrices & carry" },
    { id: "pnl.export_excel", tab: "pnl", label: "Export reports to Excel" },
    { id: "pnl.export_bonus", tab: "pnl", label: "Export bonus CSV" },
    { id: "pnl.export_gl", tab: "pnl", label: "Export GL CSV" },
    { id: "recognition.compare", tab: "recognition", label: "Compare monthly recognition impact" },
    { id: "trades.history", tab: "trades", label: "View trade history" },
    { id: "trades.documents", tab: "trades", label: "Download bilateral documents" },
];
export const DEFAULT_FINANCE_FUNCTIONS = FINANCE_FUNCTIONS.map((entry) => entry.id);
export function canUseFinanceFunction(tabs, functions, action) {
    const entry = FINANCE_FUNCTIONS.find((item) => item.id === action);
    if (!entry || !tabs?.includes(entry.tab) || !functions?.includes(action))
        return false;
    // An export cannot expose a report whose view permission is absent.
    return action !== "pnl.export_excel" || functions.includes("pnl.reports");
}
// Missing or stale permissions never grant access. The API checks the current
// user row on every request; the browser uses this same catalog for navigation.
export function canAccessFinancePath(tabs, path) {
    const tab = FINANCE_TABS.find((entry) => entry.path === path.replace(/\/$/, ""));
    return !!tab && !!tabs?.includes(tab.id) && (tab.id !== "stats" || tabs.includes("trades"));
}
export function financeLandingPath(tabs) {
    return FINANCE_TABS.find((tab) => canAccessFinancePath(tabs, tab.path))?.path ?? null;
}
//# sourceMappingURL=eex-finance-access.js.map